import { Modal } from "@/frontend/shared/ui/Modal";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import { useState } from "react";
import styles from "./DeleteCompaniesModal.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { ReactNode } from "react";
import { ConfirmationModal } from "@/frontend/shared/ui/ConfirmationModal/ConfirmationModal";

interface DeleteCompanyModalProps {
  children: ReactNode;
  onClick: () => void;
  onChange: (value: boolean) => void;
  onClose: () => void;
  isOpen: boolean;
  title?: string;
  isDeleting?: boolean;
}

export function DeleteCompaniesModal({
  children,
  onClick,
  onChange,
  isOpen,
  onClose,
  title,
  isDeleting
}: DeleteCompanyModalProps) {
  function onClickHandler() {
    onClick();
    onClose();
  }

  return (
    <div>
      <div onClick={() => onChange(true)}>{children}</div>
      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={onClickHandler}
        title={title || "Remove companies from portfolio?"}
        content="Removing these companies will take them out of the portfolio permanently. No data will be deleted, but the companies will no longer appear in the pipeline."
        dangerConfirm
        confirmButtonText="Remove"
        isDisabled={isDeleting}
      />
    </div>
  );
}
